module.exports = __webpack_public_path__ + "static/og-1377f184100f3a71a05770ba94ff93d7.png";